import MuiDrawer, { DrawerProps as MuiDrawerProps } from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';

interface DrawerProps extends MuiDrawerProps {
    drawerWidth?: number;
}

export const MobileDrawer = styled(MuiDrawer, {
    shouldForwardProp: (prop: string) => !['drawerWidth'].includes(prop),
})<DrawerProps>(({ theme, drawerWidth = 240 }) => ({
    [theme.breakpoints.down('md')]: {
        display: 'block',
    },
    [theme.breakpoints.up('md')]: {
        display: 'none',
    },

    //   [theme.breakpoints.down('sm')]: {
    // 		display: 'none',
    // },

    '& .MuiDrawer-paper': {
        width: drawerWidth,
        boxSizing: 'border-box',
        '& .MuiBox-root': {
            textAlign: 'center',
            '& .MuiButtonBase-root': {
                textAlign: 'center',
            },
        },
    },
}));
